import { HomePage } from './../../pages/home/home';

import { Component, SimpleChanges } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LoginService } from '../../services/login.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UsuarioApi, SucursalApi, RolApi, Sucursal, EmpresaApi, UsuarioSucursalApi, UsuarioRolApi } from '../../services/lbsdk';
import { Usuario } from '../../services/lbsdk/models';
import { AuthService } from '../../services/auth/auth.service';
import { ServiciosSharedService } from '../../services/servicios-shared.service';
import { UsersPage } from '../users/users';
//import { NewUser } from '../../services/lbsdk/models/CustomUser';

/**
 * Generated class for the AltaUsuarioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-alta-usuario',
  templateUrl: 'alta-usuario.html',
})
export class AltaUsuarioPage {
  rolUsuario;
  public empresaSeleccionada: any = null;
  empresa;
  empresas;
  idEmpresa: number = 0;

  sucursal;
  sucursales;
  relationEmpresas = [];
  // public NewUser: NewUser = new NewUser();
  public repPassword: string;
  registrationForm: FormGroup;
  formEmpresa: FormGroup;
  private isNewUser: boolean = true;
  private currentUser: Usuario;


  clave: string = "";
  claveConfirmacion: string = ""
  soloPassword: boolean = false;
  public roles = [];
  /* = [
    {
      id: "string",
      name: "string",
      description: "string"
    },
    {
      id: "string",
      name: "string",
      description: "string"
    },
    {
      id: "string",
      name: "string",
      description: "string"
    }
  ]*/



  constructor(public navCtrl: NavController, public navParams: NavParams,
    private _userApi: LoginService, private companyService: SucursalApi, private customUser: UsuarioApi, private rolApi: RolApi,
    private sucursalApi: SucursalApi, private usuarioApi: UsuarioApi, private empresaApi: EmpresaApi, private authService: AuthService,
    private avisos: ServiciosSharedService, private sucursalUsuario: UsuarioSucursalApi,
    private usuarioRol: UsuarioRolApi) {

    this.iniciarFormulario();
    this.empresaApi.find()
    .subscribe(respuesta => {
      this.empresas = respuesta;
      console.log(this.empresas);
      this.empresaSeleccionada = this.empresas.find(x=> x.idEmpresa== this.authService.empresaSeleccionada ) 
      console.log("**********EMPRESA ENCOTNR", this.empresaSeleccionada)
    })

    // this.idEmpresa = this.authService.empresaSeleccionada.idEmpresa;

    //this._userApi.getUserRoles().subscribe(res => {
    this.rolApi.find().subscribe(res => {
      //  alert(JSON.stringify(res))
      this.roles = res;

    

      this.currentUser = navParams.get("data");
      let aux = navParams.get("empresas");
      
      if (navParams.get("soloPassword")) {
        this.soloPassword = navParams.get("soloPassword")
      }
      console.log("EMPRESAS **********", aux)
      
     
      this.empresaSeleccionada = this.authService.empresaSeleccionada
    
      if (this.currentUser != null) {
        this.getSucursalesUsuario(this.currentUser.idusuario)
        this.isNewUser = false
        this.registrationForm.patchValue(this.currentUser);
        this.cargarSucursales(this.empresaSeleccionada)
      }
      else {
        this.isNewUser = true
        
        this.cargarSucursales(this.empresaSeleccionada)
      }
    

    }, err => { console.log("error get user roles -> ", err); });
    //  this.InitForm();
  }

  getDataEmpreas(data) {
    if (data) {
      data.forEach(async element => {
        console.log("*************ELEMENT ", element)
        let sucursal = await this.sucursalApi.findById(element.idsucursal).subscribe((res: Sucursal) => {
          //element["razonSocial"] = res.nombre;
          this.relationEmpresas.push({ name: res.nombre, idsucursal: parseInt(element.idsucursal), idusuario: this.currentUser != null ? this.currentUser.idusuario : 0 })
        })

      });
      return data;
    }
  }

  getSucursalesUsuario(idUsuario) {
    this.sucursalUsuario.find({
      where: { idusuario: idUsuario }, include: {
        relation: "Sucursal", scope: {
          include: [{ relation: "Empresa" }]
        }
      }
    }).subscribe(respuesta => {
      console.log("****RELACION USUARIO ", respuesta)
      if (respuesta) {
        respuesta.forEach((element: any) => {
          this.relationEmpresas.push({ name: element.Sucursal.nombre, idsucursal: parseInt(element.idsucursal), idusuario: this.currentUser != null ? this.currentUser.idusuario : 0 })

        })
      }
    })


    /*if (data) {
      data.forEach(async element => {
        console.log("*************ELEMENT ", element)
        let sucursal = await this.sucursalApi.findById(element.idsucursal).subscribe((res: Sucursal) => {
          //element["razonSocial"] = res.nombre;
          this.relationEmpresas.push({ name: res.nombre, idsucursal: parseInt(element.idsucursal), idusuario: this.currentUser != null ? this.currentUser.idusuario : 0 })
        })
  
      });
      return data;*/

  }

  // cargarEmpresas() {
  //   this.companyService.find()
  //     .subscribe(res => {
  //       this.sucursales = res;
  //     })
  // }

  cambiarClave() {
    if (this.clave == "") {
      alert("Debe ingresar una clave")
      return;
    }
    if (this.claveConfirmacion != this.clave) {
      alert("Las claves ingresadas no coinciden")
      return;
    }
    this.customUser.patchAttributes(this.currentUser.idusuario, { password: this.clave })
      .subscribe(res => {
        alert("Los datos fueron actualizados.")
      })

  }

  addSucursal() {
    console.log(this.formEmpresa.get('empresaform').value)
    this.sucursal = this.formEmpresa.get('empresaform').value;
    console.log("EMPRESA ", this.relationEmpresas)
    const resultado = this.relationEmpresas.find(yaEsta => yaEsta.idsucursal === this.sucursal.idsucursal);
    console.log(" SUCURSAL ", this.sucursal, " RESULTADO ", resultado)
    if (this.sucursal && !resultado) {
      this.relationEmpresas.push({ name: this.sucursal.nombre, idsucursal: this.sucursal.idsucursal, idusuario: this.currentUser != null ? this.currentUser.idusuario : 0 })
    }
  }

  quitarEmpresa(selEmpresa) {

    const arrayNew = this.relationEmpresas.filter(yaEsta => yaEsta.idsucursal != selEmpresa.idsucursal);
    this.relationEmpresas = arrayNew
  }

  compareFn(e1: any, e2: any): boolean {
    return e1 && e2 ? e1.idrol === e2.idrol : e1 === e2;
  }
  InitForm(data: any = null) {
    console.log("******************DATA 2*********", data)

    this.isNewUser = (data == null);

    if (data == null) {
      data = {}//new Usuario();
    }


    /* let role;
     let roleId = (role != null) ? role.id : '';
 
     //BUSCO ROL
     console.log("******************DATA*********", data)
     //roles.forEach(element => {
     roleId = []
     if (data.UsuarioRol != undefined) {
       data.UsuarioRol.forEach(element => {
         console.log("ROL ", element)
         roleId.push(element.idrol)
       });
     }*/
    this.rolUsuario = data.UsuarioRol




    this.registrationForm = new FormGroup({
      nombre: new FormControl(data.nombre, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      apellido: new FormControl(data.apellido, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      //  gerencia: new FormControl(data.gerencia, [Validators.required, Validators.maxLength(50)]),
      username: new FormControl(data.username, [Validators.required, Validators.minLength(2)]),
      email: new FormControl(data.email, [Validators.required, Validators.email, Validators.minLength(4)]),
      password: new FormControl(data.password, [Validators.required, Validators.minLength(6)]),
      passwordVerified: new FormControl(data.password, [Validators.required, Validators.minLength(6)]),
      roleId: new FormControl(this.rolUsuario.idrol, [Validators.required]),
      codigoVendedor: new FormControl(data.codigoVendedor)
    })

    this.formEmpresa = new FormGroup({ empresaform: new FormControl(this.sucursal, [Validators.required]) })
    if (!this.isNewUser) {
      this.registrationForm.get('password').clearValidators();
      this.registrationForm.get('passwordVerified').clearValidators();
    }


  }

  iniciarFormulario() {
    this.registrationForm = new FormGroup({
      nombre: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      apellido: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      //  gerencia: new FormControl(data.gerencia, [Validators.required, Validators.maxLength(50)]),
      username: new FormControl('', [Validators.required, Validators.minLength(2)]),
      email: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      passwordVerified: new FormControl('', [Validators.required, Validators.minLength(6)]),
      roleId: new FormControl('', [Validators.required]),
      codigoVendedor: new FormControl('')
    })

   
    this.formEmpresa = new FormGroup({ empresaform: new FormControl(this.sucursal, [Validators.required]) })
    if (!this.isNewUser) {
      this.registrationForm.get('password').clearValidators();
      this.registrationForm.get('passwordVerified').clearValidators();
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AltaUsuarioPage');
   
    //this.empresaSeleccionada = this.empresaApi.findById(7)
  }

  OnSubmit() {
    let formData = this.registrationForm.value;
    if (formData.password != formData.passwordVerified) {
      this.registrationForm.controls['passwordVerified'].setErrors({ 'incorrect': true });
      return;
    }


    formData.emailVerified = false;
    //if (this.currentUser != null) formData.id = this.currentUser.idusuario;

    if (this.currentUser != null && this.currentUser != undefined) {
      delete formData.passwordVerified;
      delete formData.password;
      formData['idusuario'] = this.currentUser.idusuario
    }
    else {
      formData['idusuario'] = 0
    }
    formData['activo'] = true
    let objeto = {
      usuario: formData,
      sucursales: this.relationEmpresas,
      roles: formData.roleId,


    }

    this.usuarioApi.AddUsuario(objeto)
      .subscribe(respuesta => {
        if (respuesta.success == false){
          this.avisos.mostrarMensajeError(respuesta.mensaje)
        }
        else{
          this.avisos.mostrarMensaje("Los datos fueron registrados correctamente.")
          this.navCtrl.push(UsersPage);
        }
      

      }, err => {
        this.avisos.mostrarMensajeError("No es posible guardar los cambios en este momento, reintente nuevamente")
      });

    /* this._userApi.OnSubmitUserData(formData, this.isNewUser, this.relationEmpresas).subscribe(res => {
    this.navCtrl.pop();
   }, err => {
     console.log("ERROR REGISTER-> ", err);
   });*/

  }

  cerrar() {
    this.navCtrl.pop();
  }

  //#region MENSAJES DE VALIDACION
  validation_messages = [
    { type: 'email', message: '* Debe ser del formato correo.' },
    { type: 'required', message: '* Este campo es requerido.' },
  ]

  //#endregion

  cargarSucursales(empresaSeleccionada) {
    console.log("EMPRESA FILTRO SUCURSALES ",)

    console.log("id inicial empresa" + empresaSeleccionada.idEmpresa);

    // MUESTRA LAS SUCURSALES SEGUN LA EMPRESA SELECCIONADA

    this.companyService.find({ where: { idempresa: empresaSeleccionada } })
      .subscribe(respuesta => {
        // alert(JSON.stringify(respuesta))
        this.sucursales = respuesta;
        console.log(this.sucursales);

      })
  }
  cambioEmpresa() {

    //SELECCIONO LA EMPRESA  
    console.log(this.empresaSeleccionada);

    this.cargarSucursales(this.empresaSeleccionada)


  }

}



// WEBPACK FOOTER //
// ./src/pages/alta-usuario/alta-usuario.ts